<h1 class="nordic-blue-900-text mr-large-b font-heading-3">
  {{ 'oneUpgrade.pageTitle.flights' | finLocalization }}
</h1>
<ng-container *finClientOnly="true">
  <fin-upgrade-flights class="block" data-testid="upgrade-flights"></fin-upgrade-flights>
</ng-container>
